import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { IntegratorRoot, Select, ThemeProvider } from '@volkswagen-onehub/components-core';
import React from 'react';
import ReactDOM from 'react-dom';

@Component({
    selector: 'app-vwsa-select',
    template: ''
})
export class VWSASelectComponent implements AfterViewInit, OnChanges, OnDestroy {
    //https://lsg-auth.prodworksngwsa.de/components-core/?path=/docs/components-select--select
    @Input() inputId = '';
    @Input() label = '';
    @Input() value: any;
    @Input() options: any[];
    @Input() isRequired = 'false';
    @Output() valueChange = new EventEmitter<string>();

    ElementToShow = () => (
        <IntegratorRoot>
            <ThemeProvider>
                <Select
                    label={this.label}
                    required={this.isRequired == 'true'}
                    value={this.value}
                    onChange={this.handleChange}>
                    {this.options && this.options.map((option: any) =>
                        <option key={option.value} value={option.value}>{option.label}</option>
                    )}
                </Select>
            </ThemeProvider>
        </IntegratorRoot>
    );

    constructor(private hostRef: ElementRef) {
        this.handleChange = this.handleChange.bind(this);
    }

    ngOnChanges(changes: SimpleChanges): void {
        //console.log('select ngOnChanges: ' + this.hostRef.nativeElement);
        this.render();
    }

    ngAfterViewInit(): void {
        //console.log('ngAfterViewInit');
        this.render();
    }

    ngOnDestroy(): void {
        //console.log('ngOnDestroy');
        //removing this for now because it causes delays when navigating.
        //find a way to call it async so it doesn't delay navigation
        //or change the navigation so pages are preloaded and also not destructed.
        //ReactDOM.unmountComponentAtNode(this.hostRef.nativeElement);
    }

    private render() {
        //console.log('select rendering');
        ReactDOM.render(<this.ElementToShow />, this.hostRef.nativeElement);
    }

    public handleChange(event: any): void {
        this.value = event.target.value;
        //console.log('select handleChange: ' + this.value);
        this.valueChange.emit(this.value);
        this.render();
    }
}
